__turbopack_context__.v({
  "columns_centered": "announcementItem-module-scss-module__xeiWMG__columns_centered",
  "columns_numeric": "announcementItem-module-scss-module__xeiWMG__columns_numeric",
  "container": "announcementItem-module-scss-module__xeiWMG__container",
});
